import { api } from '@/lib/api/client';
import type { QueuePriorityAdminView, QueuePriorityHistoryEntry, QueueRules } from './types';

// Admin Panel → Facility → Queue Prioritization. Every call is for the
// ACTIVE branch (X-Branch-Id) — the settings are per branch.

export function getQueuePriority(): Promise<QueuePriorityAdminView> {
  return api.get<QueuePriorityAdminView>('/admin/queue-priority');
}

/**
 * Saves the whole edited set. `expected_version` is the version the screen
 * loaded; if someone else saved in between the server answers 412
 * (`ApiError.code === 'conflict-stale'`) and nothing is written.
 */
export function saveQueuePriority(body: {
  rules: QueueRules;
  safeguard_enabled: boolean;
  expected_version: number;
  reason: string;
}): Promise<QueuePriorityAdminView> {
  return api.put<QueuePriorityAdminView>('/admin/queue-priority', body);
}

export function resetQueuePriority(body: { expected_version: number; reason: string }): Promise<QueuePriorityAdminView> {
  return api.post<QueuePriorityAdminView>('/admin/queue-priority/reset', body);
}

export function getQueuePriorityHistory(): Promise<QueuePriorityHistoryEntry[]> {
  return api.get<QueuePriorityHistoryEntry[]>('/admin/queue-priority/history');
}

// The read-only view the queue screens use is features/queue/api.ts's
// fetchQueuePriorityRules — a queue endpoint, not an admin one.
